<template>
    <div>
        <!-- 头像 -->
        <div class="flex3 center">
            <img class="userPhoto" :src="userInfo.headUrl ?
            userInfo.headUrl
            : '../../../static/img/default.png'"/>
            <router-link to="/user/edit" class="router">
                <div class="iconContainer">
                    <svg class="edit" aria-hidden="true" slot="icon">
                        <use xlink:href="#icon-edit"></use>
                    </svg>
                </div>
            </router-link>
        </div>
        <br />
        <!-- 用户名 -->
        <div class="flex2 center userName">{{ userInfo.nick }}</div>
        <!-- 个性签名 -->
        <p class="small_font center">{{ userInfo.sign }}</p>
    </div>
</template>

<script>

export default {
  props: ['userInfo'],
  name: 'Header'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.userPhoto {
    width:0.64rem;
    height:0.64rem;
    border-radius:50%;
    border: 3px solid #fff;
    box-sizing: border-box;
}
.userName {
    font-size: 0.20rem;
    margin-bottom: 3px;
}
.edit {
    cursor: pointer;
    width: .15rem;
    height: .15rem;
    float: right;
    margin-right: .15rem;
    color: #fff;
}
.router {
    position: absolute;
    right: 0;
}
.iconContainer svg {
    width: .2rem;
    height: .2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/userDetailElement/Header.vue